import React from 'react';

/**
 * Holds which Deal Flow view is rendered ('list' = grouped list, 'cards' = kanban board).
 * Both views live on the SAME route, so switching never changes the URL.
 * Provided by `views/deal_flow_shell`; consumed by the List/Board `ViewSwitch` in `DealListToolbar`.
 */
const DealFlowViewContext = React.createContext(null);

export const useDealFlowView = () => React.useContext(DealFlowViewContext);

export default DealFlowViewContext;
